import { createSelector } from '@reduxjs/toolkit';
import { selectProductTokenByName } from '@rsos/sinatra';
import type { SinatraState } from '@rsos/sinatra';
import { getProductName } from '@rsos/utils/metaTags';
import type { AppState } from '../types/AppState';

/**
 * Returns product token and expiration for the current product.
 * @param {Object} sinatra - sinatra state
 */
export const getProductToken = (sinatra: SinatraState) => {
  const productName = getProductName();
  const { token: productToken, expiration: productTokenExpiration } =
    selectProductTokenByName(sinatra, productName);
  return {
    productToken,
    productTokenExpiration,
  };
};

/**
 * Memoized selector for the current product tooken
 * @example
 * ```typescript
 * const { productToken, productTokenExpiration } = useSelector(selectProductToken);
 * ```
 */
export const selectProductToken = createSelector(
  (state: AppState) => state.sinatra,
  sinatra => {
    const { productToken, productTokenExpiration } = getProductToken(sinatra);
    return {
      productToken,
      productTokenExpiration,
    };
  },
);
